import { render, staticRenderFns } from "./TabsMenuComponent.vue?vue&type=template&id=7d6a62a1"
import script from "./TabsMenuComponent.vue?vue&type=script&lang=js"
export * from "./TabsMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports